// extracted by mini-css-extract-plugin
export default {"number":"SequenceNumber-module__number__qCoe-","active":"SequenceNumber-module__active__ErPpP","disabled":"SequenceNumber-module__disabled__7anmq"};